// e561c71c84520e04e36e4ce9b1e8000a0527df6f|className=EmailDraftApi|type=angular|apiName=agent|apiEnumKey=Agent|operationHash=dd79d5c4da1df9e941b906c507d70476ea0b5768|kind=api-js

import * as i0 from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Api } from '@myre/common-conf';
import {
  DynamicEnvService,
  AngularSdk,
} from '@myre/ui-domain-http';
import { parseOkResponseFromJSON } from '../../../parsers/OkResponse';

import { parseEmailDraftRequestToJSON } from '../../../parsers/EmailDraftRequest';
import { parseEmailDraftResponseFromJSON } from '../../../parsers/EmailDraftResponse';

export class EmailDraftApi extends AngularSdk {
  constructor(
    dynamicEnvService,
    httpClient,
  ) {
    super(dynamicEnvService, httpClient);
  }

  /**
   * @description <p>🔐 Auth</p><p>🛡 CustomerAuth</p><p>🛡 ChatAccessAuth</p>
   *
   * @tags EmailDraftApi
   * @name EmailDraftApiRefine
   * @summary Refine an email draft using AI assistance
   * @request POST:/customers/{customerId}/email/draft
   * @secure
   */
  refine(
    {
      customerId,
    },
    data,
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/customers/${customerId}/email/draft`,
        route: '/customers/{customerId}/email/draft',
        method: 'POST',
        body: parseEmailDraftRequestToJSON(data),
        api: Api.Agent,
      },
      {
        ...requestOptions,
        parser: data => parseOkResponseFromJSON(data, {
    contentParser: parseEmailDraftResponseFromJSON,
    isContentArray: false,
  }),
      },
    );
  }

  static ɵfac = function EmailDraftApi_Factory(t) { return new (t || EmailDraftApi)(i0.inject(DynamicEnvService), i0.inject(HttpClient)); };
  static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({ token: EmailDraftApi, factory: EmailDraftApi.ɵfac, providedIn: 'root' });
}
